module.exports = __webpack_public_path__ + "img/LogoZalo.139b4401.png";